export default {
    profileReferenceChart: {
        title: 'Fig A · Posamezni profili izdelkov',
        subtitle: 'Referenca — vsak profil prikazan posebej',
        baseLabel: 'BASE (1.0 MW ravno)',
        peakLabel: 'PEAK (2.5 MW · 08:00–20:00)',
        offPeakLabel: 'OFF_PEAK (0.8 MW · boki)',
        ariaBase: 'BASE profil: ravno 1 MW čez vseh 96 petnajstminutnih intervalov',
        ariaPeak: 'PEAK profil: 2.5 MW med 08:00 in 20:00, nič zunaj tega',
        ariaOffPeak:
            'OFF_PEAK profil: 0.8 MW med 00:00–08:00 in 20:00–24:00, nič med vršnim obdobjem',
    },
}
